import { useAuth } from "@/auth/AuthProvider";
import { ErrorNote, buttonClass } from "@/components/ui";
import { useT } from "@/i18n/LocaleProvider";

/**
 * The first thing anybody sees: what Kontora is, and one way in.
 *
 * Nothing here competes with the "Anmelden" button — the walkthroughs click it
 * by that exact text, and it is the only element on the page that carries it.
 */
export function LoginPage() {
  const { login, error } = useAuth();
  // Before sign-in there is no stored choice to read, so this screen is written
  // in whatever the browser asked for — see LocaleProvider. Greeting somebody in
  // the wrong language is a poor first sentence.
  const t = useT();

  return (
    <div className="mx-auto max-w-lg py-10 sm:py-16">
      <h1 className="text-2xl font-semibold tracking-tight text-ink sm:text-3xl">
        {t("login.title")}
      </h1>
      <p className="mt-3 max-w-prose text-base text-muted">{t("login.lead")}</p>

      <button
        type="button"
        onClick={() => void login()}
        className={`${buttonClass} mt-8 min-h-11 w-full sm:w-auto sm:px-8`}
      >
        {t("login.signIn")}
      </button>

      <ErrorNote error={error} />
    </div>
  );
}
